import { Component, Input } from '@angular/core';

@Component({
  selector: 'dynfilter-text',
  template: require('./dynamic-filters.text.component.html')
})
export class DynamicFilterTextComponent {
  @Input() filter: any;

  constructor() {}
}
